import { render, staticRenderFns } from "./Covid_archive.vue?vue&type=template&id=14255ed7&scoped=true"
import script from "./Covid_archive.vue?vue&type=script&lang=js"
export * from "./Covid_archive.vue?vue&type=script&lang=js"
import style0 from "./Covid_archive.vue?vue&type=style&index=0&id=14255ed7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14255ed7",
  null
  
)

export default component.exports